var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_8626)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_381_8626)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_381_8626)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_381_8626",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.4995V24.4995H24.5V11.4995H11.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_381_8626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9844 13.0329L18.9514 18L13.9844 22.9671L15.5173 24.5L22.0173 18L15.5173 11.5L13.9844 13.0329Z",
    fill: "url(#paint0_linear_381_8626)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_381_8626",
    x1: 14.7043,
    y1: 24.5,
    x2: 25.7516,
    y2: 17.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21A6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21A6E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_8626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_381_8626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_381_8626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.a4ae1d8d8a29e9de08284df4e328d42d.svg";
export { ForwardRef as ReactComponent };